// Spivex: Grußkarten mit 8 Motiven (28.10.2026)
// 29.10.2026: beim Doppelpaket gleich aufgeklappt (istDoppel).
// 29.10.2026 (2): Textfeld immer frei, Text eintippen setzt das Kreuz beim Motiv (durchText).
// 29.10.2026 (3): Text im Feld = Kreuz gesetzt, auch nach Paketwechsel (außer selbst entfernt: abgewaehlt).
// 29.10.2026 (4): Teile werden nach dem Paketwechsel neu geholt (auffrischen), Ereignisse hängen am Element selbst.
// 28.10.2026 abends: beim Neuladen leer, nur bewusstes Weitergehen nimmt Motiv und Text mit (siehe MITNEHMEN).
// <spivex-grusskarten data-modus="wahl">  Produktseite und Konfigurator (snippets/spivex-grusskarten-wahl.liquid)
// <spivex-grusskarten data-modus="seite"> Geschenkideen-Seite, Schritt 1 (sections/spivex-grusskarten-auswahl.liquid)
//
// Gemerkt wird in sessionStorage („spivex-grusskarte“): vorgemerkt (auf der Geschenkseite angeschaut), gewaehlt
// (auf der Produktseite angekreuzt) und der Text. So bleiben Motiv, Kreuz und Text beim Paketwechsel (der
// Paket-Picker tauscht den Produktbereich aus) und auf weiteren Seiten erhalten.
// Angekreuzt wird nur von der Kundin selbst (nie vorausgewählt, § 312a Abs. 3 BGB). Liegt die Karte im Warenkorb
// (assets/spivex-zusatz.js meldet „spivex:zusatz-hinzugefuegt“), wird alles zurückgesetzt.
(function () {
  if (customElements.get('spivex-grusskarten')) return;

  var SPEICHER = 'spivex-grusskarte';
  var WEITER = 'spivex-grusskarte-weiter';

  // 28.10.2026: Motiv, Kreuz und Text kommen nur mit, wenn man bewusst weitergeht: Set-Finder „Paket ansehen“ oder
  // „Set ändern“, Geschenkideen-Seite zum Paket (Links mit data-gk-mitnehmen gehen auch). Beim Neuladen und bei
  // jedem anderen Seitenwechsel fängt die Grußkarte leer an. Der Paketwechsel auf der Produktseite lädt die Seite
  // nicht neu, dort bleibt alles.
  var MITNEHMEN = '.spivex-quiz__links a, [data-paket-link], .spivex-pack__cta, .spivex-double__cta, [data-gk-mitnehmen]';
  (function aufraeumen() {
    try {
      var weiter = Number(sessionStorage.getItem(WEITER) || 0);
      sessionStorage.removeItem(WEITER);
      var nav = performance.getEntriesByType ? performance.getEntriesByType('navigation')[0] : null;
      var neuGeladen = nav && nav.type === 'reload';
      if (neuGeladen || !(Date.now() - weiter < 2 * 60 * 1000)) sessionStorage.removeItem(SPEICHER);
    } catch (e) {}
  })();
  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest(MITNEHMEN);
    if (!link) return;
    try {
      sessionStorage.setItem(WEITER, String(Date.now()));
    } catch (e2) {}
  }, true);

  // 29.10.2026: Doppelpaket gewählt? Produktseite: Paketwahl mit data-doppel; Konfigurator: aktuelle Auswahl
  function istDoppel() {
    if (document.querySelector('spivex-bundle-picker[data-doppel]')) return true;
    return !!(window.spivexAktuelleAuswahl && window.spivexAktuelleAuswahl.doppel);
  }

  function lesen() {
    try {
      return JSON.parse(sessionStorage.getItem(SPEICHER) || 'null') || {};
    } catch (e) {
      return {};
    }
  }
  function schreiben(daten) {
    try {
      sessionStorage.setItem(SPEICHER, JSON.stringify(daten));
    } catch (e) {}
  }

  class SpivexGrusskarten extends HTMLElement {
    connectedCallback() {
      if (this._bereit) {
        this.anwenden();
        return;
      }
      this._bereit = true;
      this.karten = Array.prototype.slice.call(this.querySelectorAll('[data-gk-karte]'));
      if (!this.karten.length) return;
      this.spur = this.querySelector('[data-gk-spur]');
      this.text = this.querySelector('[data-gk-text]');
      this.hinten = false;

      var gemerkt = lesen();
      this.vorgemerkt = this.finden(gemerkt.vorgemerkt) ? gemerkt.vorgemerkt : null;
      this.gewaehlt = this.finden(gemerkt.gewaehlt) ? gemerkt.gewaehlt : null;
      this.textWert = gemerkt.text || '';
      this.abgewaehlt = !!gemerkt.abgewaehlt;
      if (this.text) this.text.value = this.textWert;

      if (this.dataset.modus === 'seite') this.seiteEinrichten();
      else this.wahlEinrichten();
    }

    finden(handle) {
      if (!handle) return null;
      for (var i = 0; i < this.karten.length; i++) {
        if (this.karten[i].dataset.handle === handle) return this.karten[i];
      }
      return null;
    }

    sichtbare() {
      return this.karten.filter(function (k) { return !k.hidden; });
    }

    speichern() {
      schreiben({ vorgemerkt: this.vorgemerkt, gewaehlt: this.gewaehlt, text: this.textWert, abgewaehlt: !!this.abgewaehlt });
    }

    zeigeKarte(karte, sanft) {
      if (!karte || !this.spur) return;
      var links = karte.offsetLeft - (this.spur.clientWidth - karte.offsetWidth) / 2;
      this.spur.scrollTo({ left: Math.max(0, links), behavior: sanft ? 'smooth' : 'auto' });
    }

    drehen() {
      this.hinten = !this.hinten;
      this.classList.toggle('spivex-gk--hinten', this.hinten);
      var knopf = this.querySelector('[data-gk-drehen]');
      var text = this.querySelector('[data-gk-drehen-text]');
      if (knopf) knopf.setAttribute('aria-pressed', this.hinten ? 'true' : 'false');
      if (text) text.textContent = this.hinten ? text.dataset.hinten : text.dataset.vorne;
    }

    // ---------- Produktseite und Konfigurator ----------
    // 29.10.2026 (4): Der Paketwechsel auf der Produktseite baut das Innere neu auf (Textfeld, Kreuz, Karten). Darum
    // holt auffrischen() die Teile jedes Mal neu, und alle Klicks/Eingaben hängen am Grußkarten-Element selbst
    // (nicht an einzelnen Feldern, die danach nicht mehr auf der Seite sind).
    auffrischen() {
      var vorher = this.angesehen;
      this.karten = Array.prototype.slice.call(this.querySelectorAll('[data-gk-karte]'));
      this.spur = this.querySelector('[data-gk-spur]');
      this.text = this.querySelector('[data-gk-text]');
      this.box = this.querySelector('[data-gk-box]');
      this.wechsel = this.querySelector('[data-gk-wechsel]');
      this.idFeld = this.querySelector('[data-gk-id]');
      if (vorher && !this.contains(vorher)) {
        this.angesehen = this.finden(vorher.dataset.handle) || this.karten[0];
      }
      if (!this.angesehen) this.angesehen = this.karten[0];
    }

    // ---------- Produktseite und Konfigurator ----------
    wahlEinrichten() {
      var self = this;
      this.alle = false;
      // 29.10.2026: beim Doppelpaket (Produktseite oder Konfigurator) gleich aufgeklappt
      this.offen = !!(this.vorgemerkt || this.gewaehlt) || this.hasAttribute('data-start-offen') || istDoppel();
      this.auffrischen();
      this.angesehen = this.finden(this.gewaehlt) || this.finden(this.vorgemerkt) || this.karten[0];

      this.addEventListener('click', function (e) {
        var ziel = e.target instanceof Element ? e.target : null;
        if (!ziel) return;
        self.auffrischen();
        if (ziel.closest('[data-gk-aufzu]')) {
          self.offen = !self.offen;
          self.anwenden();
          if (self.offen) self.zeigeKarte(self.angesehen, false);
          return;
        }
        if (ziel.closest('[data-gk-zurueck]')) { self.blaettern(-1); return; }
        if (ziel.closest('[data-gk-weiter]')) { self.blaettern(1); return; }
        if (ziel.closest('[data-gk-drehen]')) { self.drehen(); return; }
        if (ziel.closest('[data-gk-alle]')) {
          self.alle = true;
          self.anwenden();
          self.zeigeKarte(self.angesehen, false);
          return;
        }
        var k = ziel.closest('[data-gk-karte]');
        if (k && self.contains(k)) {
          // Antippen wählt das Motiv, nochmal antippen nimmt es wieder heraus
          self.angesehen = k;
          self.gewaehlt = self.gewaehlt === k.dataset.handle ? null : k.dataset.handle;
          self.durchText = false;
          self.speichern();
          self.anwenden();
          if (!self.raster) self.zeigeKarte(k, true);
        }
      });

      // Schmal (eine Karte): angesehen ist die Karte, auf der das Wischen stehen bleibt
      var warten;
      this.addEventListener('scroll', function (e) {
        if (self.raster || !(e.target instanceof Element) || !e.target.matches('[data-gk-spur]')) return;
        clearTimeout(warten);
        warten = setTimeout(function () {
          self.auffrischen();
          var liste = self.sichtbare();
          var breite = liste[0] ? liste[0].offsetWidth + 10 : 1;
          var k = liste[Math.round(self.spur.scrollLeft / breite)];
          if (k && k !== self.angesehen) {
            self.angesehen = k;
            self.anwenden();
          }
        }, 120);
      }, { capture: true, passive: true });

      this.addEventListener('change', function (e) {
        var ziel = e.target instanceof Element ? e.target : null;
        if (!ziel) return;
        if (ziel.matches('[data-gk-box]')) {
          if (self._still) return;
          self.auffrischen();
          self.gewaehlt = ziel.checked ? self.angesehen.dataset.handle : null;
          self.durchText = false;
          // Kreuz bei vorhandenem Text bewusst entfernt: dann nicht wieder von selbst setzen
          self.abgewaehlt = !ziel.checked && self.textWert.trim() !== '';
          self.speichern();
          self.anwenden();
          return;
        }
        if (ziel.matches('[data-gk-wechsel]')) {
          if (!ziel.checked) return;
          ziel.checked = false;
          self.auffrischen();
          self.gewaehlt = self.angesehen.dataset.handle;
          self.speichern();
          self.anwenden();
        }
      });
      // 29.10.2026: Text eintippen setzt das Kreuz beim angesehenen Motiv (die Kundin tippt selbst, der Hinweis im
      // Feld nennt den Preis). Wird der Text wieder ganz gelöscht, geht ein so gesetztes Kreuz wieder raus.
      this.addEventListener('input', function (e) {
        var feld = e.target instanceof Element && e.target.matches('[data-gk-text]') ? e.target : null;
        if (!feld) return;
        self.auffrischen();
        self.textWert = feld.value;
        var hatText = feld.value.trim() !== '';
        var neu = false;
        if (!hatText) self.abgewaehlt = false;
        if (hatText && !self.gewaehlt && !self.abgewaehlt && self.angesehen) {
          self.gewaehlt = self.angesehen.dataset.handle;
          self.durchText = true;
          neu = true;
        } else if (!hatText && self.durchText) {
          self.gewaehlt = null;
          self.durchText = false;
          neu = true;
        }
        self.speichern();
        if (neu) self.anwenden();
      });
      // Karte liegt im Warenkorb: zurücksetzen (das Ereignis kommt vom Kreuz und steigt bis hierher auf)
      this.addEventListener('spivex:zusatz-hinzugefuegt', function () {
        self.durchText = false;
        self.abgewaehlt = false;
        self.gewaehlt = null;
        self.vorgemerkt = null;
        self.textWert = '';
        self.speichern();
        self.anwenden();
      });
      // Paketwechsel auf der Produktseite: der Bereich wird neu aufgebaut, Auswahl und Text wieder eintragen
      document.addEventListener('spivex:bundle-change', function () {
        requestAnimationFrame(function () {
          if (istDoppel()) self.offen = true;
          self.anwenden();
        });
        // 29.10.2026 (3): nach dem Austausch des Produktbereichs noch einmal, falls er Kreuz oder Text zurückgesetzt hat
        setTimeout(function () { self.anwenden(); }, 400);
      });
      // Konfigurator: Doppelpaket gewählt (Ereignis spivex:auswahl mit doppel: true)
      document.addEventListener('spivex:auswahl', function (e) {
        if (!e.detail || !e.detail.doppel || self.offen) return;
        self.offen = true;
        self.anwenden();
      });

      if (window.ResizeObserver) {
        new ResizeObserver(function () {
          var raster = false;
          if (raster !== self.raster) {
            self.raster = raster;
            self.anwenden();
          }
        }).observe(this);
      }
      this.raster = false;
      this.anwenden();
      if (this.offen) {
        var self2 = this;
        requestAnimationFrame(function () { self2.zeigeKarte(self2.angesehen, false); });
      }
    }

    blaettern(richtung) {
      if (this.raster) {
        this.spur.scrollBy({ left: richtung * this.spur.clientWidth, behavior: 'smooth' });
        return;
      }
      var liste = this.sichtbare();
      var i = liste.indexOf(this.angesehen);
      var k = liste[(i + richtung + liste.length) % liste.length];
      this.angesehen = k;
      this.anwenden();
      this.zeigeKarte(k, true);
    }

    anwenden() {
      if (this.dataset.modus !== 'seite') this.auffrischen();
      if (!this.box || !this.angesehen) return;
      var self = this;
      // 29.10.2026 (3): Steht Text im Feld, ist ein Motiv gewählt (außer die Kundin hat das Kreuz selbst entfernt)
      if (this.textWert && this.textWert.trim() !== '' && !this.gewaehlt && !this.abgewaehlt && this.angesehen) {
        this.gewaehlt = this.angesehen.dataset.handle;
        this.durchText = true;
        this.speichern();
      }
      var nurEins = !!this.vorgemerkt && !this.alle;
      var gewaehlteKarte = this.finden(this.gewaehlt);
      if (nurEins) this.angesehen = this.finden(this.vorgemerkt);

      this.classList.toggle('spivex-gk--raster', !!this.raster);
      this.classList.toggle('spivex-gk--eins', nurEins);

      var kopf = this.querySelector('[data-gk-aufzu]');
      var aufzuText = this.querySelector('[data-gk-aufzu-text]');
      kopf.setAttribute('aria-expanded', this.offen ? 'true' : 'false');
      aufzuText.textContent = this.offen ? aufzuText.dataset.auf : aufzuText.dataset.zu;
      // Zugeklappt mit gewählter Karte: „Motiv 3 ausgewählt“ statt „Ist es ein Geschenk?“
      var titel = this.querySelector('[data-gk-titel]');
      if (titel) {
        var gewaehltNr = this.finden(this.gewaehlt);
        titel.textContent = !this.offen && gewaehltNr ? 'Motiv ' + gewaehltNr.dataset.nr + ' ausgewählt' : titel.dataset.text;
      }
      this.querySelector('.spivex-gk__inhalt').hidden = !this.offen;

      this.karten.forEach(function (k) {
        k.hidden = nurEins && k.dataset.handle !== self.vorgemerkt;
        k.toggleAttribute('data-gewaehlt', k === gewaehlteKarte);
        k.toggleAttribute('data-angesehen', k === self.angesehen);
        k.setAttribute('aria-pressed', k === self.angesehen ? 'true' : 'false');
      });

      this.querySelector('[data-gk-zurueck]').hidden = nurEins;
      this.querySelector('[data-gk-weiter]').hidden = nurEins;
      this.querySelector('[data-gk-alle]').hidden = !nurEins;

      var punkte = this.querySelector('[data-gk-punkte]');
      punkte.innerHTML = '';
      punkte.hidden = nurEins || this.raster;
      if (!punkte.hidden) {
        this.karten.forEach(function (k) {
          var p = document.createElement('span');
          if (k === gewaehlteKarte) p.className = 'ist-gewaehlt';
          if (k === self.angesehen) p.className = 'ist-aktiv';
          punkte.appendChild(p);
        });
      }

      // Das Kreuz: angekreuzt nur, wenn die Kundin es gesetzt hat
      var ziel = gewaehlteKarte || this.angesehen;
      this._still = true;
      this.box.checked = !!gewaehlteKarte;
      this.box.dataset.variantId = ziel.dataset.variantId;
      this.box.dataset.spivexPreis = ziel.dataset.preis;
      if (this.idFeld) this.idFeld.value = ziel.dataset.variantId;
      this.box.dispatchEvent(new Event('change', { bubbles: true }));
      this._still = false;

      this.querySelector('[data-gk-zeile-text]').textContent = gewaehlteKarte
        ? 'Motiv (' + gewaehlteKarte.dataset.nr + ')'
        : 'Dieses Motiv (' + this.angesehen.dataset.nr + ') nehmen';

      var wechselZeile = this.querySelector('[data-gk-wechsel-zeile]');
      wechselZeile.hidden = !gewaehlteKarte || gewaehlteKarte === this.angesehen;
      this.wechsel.checked = false;
      this.querySelector('[data-gk-wechsel-text]').textContent = 'Stattdessen Motiv (' + this.angesehen.dataset.nr + ') nehmen';

      // 29.10.2026: nie gesperrt (auch nicht, wenn der Paketwechsel das Feld neu einsetzt)
      this.text.disabled = false;
      this.text.removeAttribute('disabled');
      this.text.placeholder = gewaehlteKarte ? (this.text.dataset.beispiel || '') : this.text.dataset.leer;
      if (this.text.value !== this.textWert) this.text.value = this.textWert;
    }

    // ---------- Geschenkideen-Seite ----------
    seiteEinrichten() {
      var self = this;
      this.ausgabe = this.querySelector('[data-gk-wahl-text]');
      this.hinweis = this.querySelector('[data-gk-hinweis]');
      this.angesehen = this.finden(this.vorgemerkt) || this.karten[Math.min(2, this.karten.length - 1)];

      this.band = this.querySelector('.spivex-gk-seite__band');
      this.karten.forEach(function (k) {
        k.addEventListener('click', function () {
          // Antippen wählt das Motiv, nochmal antippen nimmt es wieder heraus
          self.vorgemerkt = self.vorgemerkt === k.dataset.handle ? null : k.dataset.handle;
          self.angesehen = k;
          self.speichern();
          self.seiteAnwenden();
        });
      });
      this.querySelector('[data-gk-zurueck]').addEventListener('click', function () { self.seiteBlaettern(-1); });
      this.querySelector('[data-gk-weiter]').addEventListener('click', function () { self.seiteBlaettern(1); });
      // Pfeile und Ausblenden nur in Richtungen, in denen es noch Karten gibt
      var planen = false;
      this.spur.addEventListener('scroll', function () {
        if (planen) return;
        planen = true;
        requestAnimationFrame(function () { planen = false; self.pfeileAnpassen(); });
      }, { passive: true });
      window.addEventListener('resize', function () { self.pfeileAnpassen(); });
      var dreh = this.querySelector('[data-gk-drehen]');
      if (dreh) dreh.addEventListener('click', function () { self.drehen(); });
      if (this.text) {
        this.text.addEventListener('input', function () {
          self.textWert = self.text.value;
          self.speichern();
        });
      }

      // Pakete darunter: „Paket auswählen“ erst, wenn ein Motiv gewählt ist
      document.addEventListener('click', function (e) {
        var cta = e.target.closest && e.target.closest('.spivex-pack__cta, .spivex-double__cta');
        if (!cta || self.vorgemerkt) return;
        e.preventDefault();
        if (self.hinweis) self.hinweis.hidden = false;
        self.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }, true);

      this.seiteAnwenden();
      requestAnimationFrame(function () {
        if (self.vorgemerkt) self.zeigeKarte(self.angesehen, false);
        self.pfeileAnpassen();
      });
    }

    pfeileAnpassen() {
      var links = this.spur.scrollLeft > 2;
      var rechts = this.spur.scrollLeft + this.spur.clientWidth < this.spur.scrollWidth - 2;
      this.querySelector('[data-gk-zurueck]').hidden = !links;
      this.querySelector('[data-gk-weiter]').hidden = !rechts;
      if (this.band) {
        this.band.classList.toggle('kann-links', links);
        this.band.classList.toggle('kann-rechts', rechts);
      }
    }

    seiteBlaettern(richtung) {
      // Handy: genau eine Karte weiter und in die Mitte
      if (window.matchMedia('(max-width: 749px)').matches) {
        var mitte = this.spur.scrollLeft + this.spur.clientWidth / 2;
        var self = this;
        var aktuell = this.karten.reduce(function (best, k) {
          var abstand = Math.abs(k.offsetLeft + k.offsetWidth / 2 - mitte);
          return !best || abstand < best.abstand ? { karte: k, abstand: abstand } : best;
        }, null);
        var i = aktuell ? this.karten.indexOf(aktuell.karte) : 0;
        var ziel = this.karten[Math.max(0, Math.min(this.karten.length - 1, i + richtung))];
        self.zeigeKarte(ziel, true);
        return;
      }
      var schritt = this.karten[0] ? this.karten[0].offsetWidth + 24 : this.spur.clientWidth;
      var sichtbar = Math.max(1, Math.floor(this.spur.clientWidth / schritt));
      this.spur.scrollBy({ left: richtung * schritt * sichtbar, behavior: 'smooth' });
    }

    seiteAnwenden() {
      var self = this;
      var gewaehlteKarte = this.finden(this.vorgemerkt);
      this.karten.forEach(function (k) {
        k.toggleAttribute('data-gewaehlt', k === gewaehlteKarte);
        k.toggleAttribute('data-angesehen', k === self.angesehen);
        k.setAttribute('aria-pressed', k === gewaehlteKarte ? 'true' : 'false');
      });
      if (this.ausgabe) {
        this.ausgabe.textContent = gewaehlteKarte
          ? 'Dein Motiv: ' + gewaehlteKarte.dataset.nr
          : this.ausgabe.dataset.leer;
      }
      if (gewaehlteKarte && this.hinweis) this.hinweis.hidden = true;
      document.querySelectorAll('.spivex-pack__cta, .spivex-double__cta').forEach(function (cta) {
        cta.classList.toggle('spivex-gk-gesperrt', !gewaehlteKarte);
        if (gewaehlteKarte) cta.removeAttribute('aria-disabled');
        else cta.setAttribute('aria-disabled', 'true');
      });
    }
  }

  customElements.define('spivex-grusskarten', SpivexGrusskarten);
})();
